// extracted by mini-css-extract-plugin
export default {"container":"gE-z","brandName":"hE-z","productName":"iE-z","aboveGalleryInfo":"jE-z","belowGalleryInfo":"kE-z","breakLongProductName":"lE-z"};